// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oUHh","controls":"styles_controls__13DPW","charLimit":"styles_charLimit__2N5KS","input":"styles_input__zU-Ow","send":"styles_send__2kmmX"};